import React, { createContext, memo, useReducer, useMemo } from 'react';
import { defaultPagesState, pageReducer } from './pageReducer';
var store = createContext({
    page: defaultPagesState,
    dispatchPage: function () {
    }
});
var Provider = store.Provider;
export var usePage = function () {
    var _a = React.useContext(store), page = _a.page, dispatchPage = _a.dispatchPage;
    var isLandingPage = useMemo(function () { return page.data.id === 'landing'; }, [page.data.id]);
    var pageIsFetching = useMemo(function () { return page.isFetching; }, [page.isFetching]);
    var pageId = useMemo(function () { return page.data.id; }, [page.data.id]);
    var pageVersion = useMemo(function () { return page.data.version; }, [page.data.version]);
    var pageTitle = useMemo(function () { return page.data.title; }, [page.data.title]);
    var pagePhotoURL = useMemo(function () { return page.data.photoURL; }, [page.data.photoURL]);
    var pageShowFooter = useMemo(function () { return page.data.footer !== false; }, [page.data.footer]);
    return { isLandingPage: isLandingPage, page: page, dispatchPage: dispatchPage, pageIsFetching: pageIsFetching, pageId: pageId, pageVersion: pageVersion, pageTitle: pageTitle, pagePhotoURL: pagePhotoURL, pageShowFooter: pageShowFooter };
};
export var PageProvider = memo(function (_a) {
    var children = _a.children;
    var _b = useReducer(pageReducer, defaultPagesState), page = _b[0], dispatchPage = _b[1];
    return (React.createElement(Provider, { value: { page: page, dispatchPage: dispatchPage } }, children));
});
